import { useCallback, useState } from 'react';
import { FileError } from 'react-dropzone';

const useFileErrorPopup = () => {
  const [isFileUploadErrorModalVisible, setIsFileUploadErrorModalVisible] = useState(false);
  const [fileUploadError, setFileUploadError] = useState<FileError | undefined>();

  const onFileUploadError = useCallback((error?: FileError) => {
    setFileUploadError(error);
    setIsFileUploadErrorModalVisible(true);
  }, []);

  const onCloseFileUploadError = useCallback(() => {
    setFileUploadError(undefined);
    setIsFileUploadErrorModalVisible(false);
  }, []);

  return {
    isFileUploadErrorModalVisible,
    fileUploadError,
    onFileUploadError,
    onCloseFileUploadError,
  };
};

export default useFileErrorPopup;
